export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='#page-top'>
            Mutant Punks NFT
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='#features' className='page-scroll'>
                Yield Claim
              </a>
            </li>
            <li>
              <a href='#team' className='page-scroll'>
                Punk Species
              </a>
            </li>
            <li>
              <a href='https://hackmd.io/@mutantpunksnft/whitepaper' target='_blank' className='page-scroll'>
                Roadmap
              </a>
            </li>
            <li>
              <a href='https://docs.mutantswap.finance/' target='_blank' className='page-scroll'>
                Mutant Swap
              </a>
            </li>
            <li>
              <a href='#contact' className='page-scroll'>
                Connect
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
